export default () => {
  return screen.width > 700 && screen.width < 1400;
};
